import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_17 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_20 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_21 = { class: "form-group d-flex flex-wrap" }
const _hoisted_22 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group d-flex flex-wrap" }
const _hoisted_26 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group d-flex flex-wrap" }
const _hoisted_29 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group d-flex flex-wrap" }
const _hoisted_33 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group d-flex flex-wrap" }
const _hoisted_36 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group d-flex align-items-center flex-wrap" }
const _hoisted_40 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-8" }
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-group d-flex flex-wrap" }
const _hoisted_46 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("€")
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-6" }
const _hoisted_50 = { class: "form-group d-flex flex-wrap" }
const _hoisted_51 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "form-group d-flex flex-wrap" }
const _hoisted_54 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-12" }
const _hoisted_57 = { class: "form-group d-flex flex-wrap" }
const _hoisted_58 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_60 = { class: "mb-0" }
const _hoisted_61 = { class: "mb-10" }
const _hoisted_62 = { class: "svg-icon svg-icon-3" }
const _hoisted_63 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_65 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_66 = { class: "indicator-label" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_68 = { class: "indicator-progress" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_70 = { class: "card mb-5 mb-xl-10" }
const _hoisted_71 = { class: "card-header border-0" }
const _hoisted_72 = { class: "card-title m-0" }
const _hoisted_73 = { class: "fw-boldest m-0" }
const _hoisted_74 = { class: "card-body border-top p-9" }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { class: "form-group d-flex flex-wrap" }
const _hoisted_78 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_79 = { class: "el-form-item__content" }
const _hoisted_80 = { class: "col-md-6" }
const _hoisted_81 = { class: "form-group d-flex flex-wrap" }
const _hoisted_82 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_83 = { class: "el-form-item__content" }
const _hoisted_84 = { class: "col-md-6" }
const _hoisted_85 = { class: "form-group d-flex flex-wrap" }
const _hoisted_86 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_87 = { class: "el-form-item__content" }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "form-group d-flex flex-wrap" }
const _hoisted_90 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_91 = { class: "el-form-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("interactiveActivities.information")), 1)
        ])
      ]),
      _createVNode(_component_el_form, {
        onSubmit: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        model: _ctx.formData,
        rules: _ctx.rules,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("interactiveActivities.targetName")), 1),
                  _createVNode(_component_el_form_item, { prop: "target_name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.target_name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.target_name) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("interactiveActivities.targetOwner")), 1),
                  _createVNode(_component_el_form_item, { prop: "target_owner" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.target_owner,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.target_owner) = $event)),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        "remote-method": _ctx.searchOwnerItems,
                        loading: _ctx.ownerLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownerOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("interactiveActivities.targetType")), 1),
                  _createVNode(_component_el_form_item, { prop: "target_type" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.target_type,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.target_type) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.targetTypeCheng($event)))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.formData.target_type == 1 || _ctx.formData.target_type == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("interactiveActivities.influencer")), 1),
                      _createVNode(_component_el_form_item, { prop: "account_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.account_id,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.account_id) = $event)),
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            clearable: "",
                            placeholder: _ctx.t('common.plsEnter'),
                            "remote-method": _ctx.searchInfluencerItems,
                            loading: _ctx.influencerLoading,
                            disabled: 
                    _ctx.formData.target_type == '' || _ctx.formData.target_type == null
                  ,
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.influencerOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder", "remote-method", "loading", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.target_type == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("interactiveActivities.accountGroups")), 1),
                      _createVNode(_component_el_form_item, { prop: "account_groups_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.account_groups_id,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.account_groups_id) = $event)),
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            clearable: "",
                            placeholder: _ctx.t('common.plsEnter'),
                            "remote-method": _ctx.searchInfluencerGroupSourceData,
                            loading: _ctx.influencerGroupLoading,
                            disabled: 
                    _ctx.formData.target_type == '' || _ctx.formData.target_type == null
                  ,
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.influencerGroupOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder", "remote-method", "loading", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("interactiveActivities.mbSegmentation")), 1),
                  _createVNode(_component_el_form_item, { prop: "mb_segmentation" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.mb_segmentation,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.mb_segmentation) = $event)),
                        clearable: "",
                        multiple: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t("interactiveActivities.start")), 1),
                  _createVNode(_component_el_form_item, { prop: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.start,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.start) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.commonChangeDefaultDate($event, _ctx.formData, 'start')))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("interactiveActivities.closeDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "close_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.close_date,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.close_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'close_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("interactiveActivities.stage")), 1),
                  _createVNode(_component_el_form_item, { prop: "stage" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.stage,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.stage) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stageOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("interactiveActivities.probability")), 1),
                  _createVNode(_component_el_form_item, { prop: "probability" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_el_slider, {
                            modelValue: _ctx.formData.probability,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.probability) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.formData.probability) + "%", 1)
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.t("interactiveActivities.targetAmount")), 1),
                  _createVNode(_component_el_form_item, { prop: "target_amount" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.target_amount,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.target_amount) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter')
                      }, {
                        prepend: _withCtx(() => [
                          _hoisted_47
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.t("interactiveActivities.completion")), 1),
                  _createVNode(_component_el_form_item, { prop: "completion" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.completion,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.completion) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.t("interactiveActivities.requriedResources")), 1),
                  _createVNode(_component_el_form_item, { prop: "requried_resources" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.requried_resources,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.requried_resources) = $event)),
                        multiple: "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requriedResourcesOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.t("interactiveActivities.note")), 1),
                  _createVNode(_component_el_form_item, { prop: "note" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.note,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.note) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("h3", _hoisted_60, _toDisplayString(_ctx.t("interactiveActivities.relatedCampaigns")), 1)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createVNode(_component_el_table, {
                data: _ctx.formData.campaign,
                style: {"width":"100%"},
                size: "small",
                "min-width": "220"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('marketingCampaigns.campaignName'),
                    prop: "name"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('marketingCampaigns.campaignPurpose'),
                    prop: "__show.purpose"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('marketingCampaigns.startDate')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(row.start_date)), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('marketingCampaigns.endDate')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(row.end_date)), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('marketingCampaigns.status')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", _ctx.getStatusLabel(row.status).statusClass])
                      }, _toDisplayString(_ctx.getStatusLabel(row.status).str), 3)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: "",
                    width: "100",
                    align: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_router_link, {
                        to: 
                    '/interactive-marketing/marketing-campaigns/' +
                    row.id +
                    '/Information'
                  ,
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_62, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createVNode(_component_router_link, {
              to: '/interactive-marketing/interactive-activities/',
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _hoisted_64,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_65, [
              _createElementVNode("span", _hoisted_66, [
                _hoisted_67,
                _createTextVNode(_toDisplayString(_ctx.t("common.saveChanges")), 1)
              ]),
              _createElementVNode("span", _hoisted_68, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_69
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _createElementVNode("div", _hoisted_70, [
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("h3", _hoisted_73, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_79, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_user,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.__show.created_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_83, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_87, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_user,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.__show.updated_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_91, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ])
  ], 64))
}